<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      border="inner"
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :height="tableHeight"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      row-id="userCode"
      :radio-config="
        !multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              strict: false,
              reserve: reserve,
            }
          : {}
      "
      :checkbox-config="
        multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              reserve: reserve,
            }
          : {}
      "
      @radio-change="radioChange"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>
      <template #pager>
        <slot name="pager"></slot>
      </template>
      <template #empty>
        <div class="text-center">
          <img src="/image/static/img/nodata.png" />
          <p class="m-0 mt-2">
            {{ $l("INDEX.table_label_empty") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import tableColumns from "./TableColumns";

export default {
  props: {
    tableHeight: { type: Number, default: 800 },
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: true },
    highlight: { type: Boolean, default: true },
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  computed: {
    columns() {
      return tableColumns(this);
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit("chooseChange", records.concat(reserves));
    },
    radioChange({ newValue }) {
      this.$emit("chooseChange", newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
